import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getPagePath, trans } from '@spotahome/soyuz/client';

import { Link } from '../../../..';
import FAQAccordion from '../FAQSection/FAQAccordion';

import LandingSection from '../LandingSection/LandingSection';

import styles from './LandingFaqsSection.module.scss';

const LandingFaqsSection = ({
  faqs = [],
  backgroundColor = 'tertiary',
  observableSection = null
}) => {
  return (
    <LandingSection
      className={classNames(
        styles['landing-faqs-section__wrapper'],
        styles[`landing-faqs-section__wrapper--${backgroundColor}`]
      )}
      containerClassName={styles['landing-faqs-section']}
      observableSection={observableSection}
    >
      <div className={styles['landing-faqs-section__title-container']}>
        <h2 className={styles['landing-faqs-section__title']}>
          {trans('how-it-works.faqs.title')}
        </h2>
        <p className={styles['landing-faqs-section__subtitle']}>
          {trans('how-it-works.faqs.subtitle')}
        </p>
        <Link
          href={getPagePath('externals.help-center')}
          bold
          className={styles['landing-faqs-section__help-link']}
        >
          {trans('how-it-works.faqs.help-link')}
        </Link>
      </div>
      <FAQAccordion
        data={faqs}
        theme="how-it-works"
        titleTag="p"
        className={styles['landing-faqs-section__faqs-accordion']}
      />
    </LandingSection>
  );
};

LandingFaqsSection.propTypes = {
  faqs: PropTypes.arrayOf(
    PropTypes.shape({
      top: PropTypes.node.isRequired,
      content: PropTypes.node.isRequired,
      isOpened: PropTypes.bool
    })
  ).isRequired,
  backgroundColor: PropTypes.oneOf(['tertiary', 'white']),
  observableSection: PropTypes.string
};

export default LandingFaqsSection;
